import { render, staticRenderFns } from "./TaxadeEsforco.vue?vue&type=template&id=73ccf8fc&scoped=true&"
import script from "./TaxadeEsforco.vue?vue&type=script&lang=js&"
export * from "./TaxadeEsforco.vue?vue&type=script&lang=js&"
import style0 from "./TaxadeEsforco.vue?vue&type=style&index=0&id=73ccf8fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ccf8fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCard,VCol,VProgressCircular,VRow})
